/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Siparis_IptalInputs */

const tr_faq_a_siparis_iptal = /** @type {(inputs: Faq_A_Siparis_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İptal etmek istediğin siparişi açıp İptal Et butonuna bas. Her pazaryerinin iptal kuralları farklıdır: Trendyol ve n11'de kargoya verilmemiş siparişleri iptal edebilirsin, Hepsiburada'da iptal talebi pazaryeri onayına gider. Fatura kesilmişse otomatik iptal faturası da oluşturulur.`)
};

const en_faq_a_siparis_iptal = /** @type {(inputs: Faq_A_Siparis_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the order and click Cancel. Cancellation rules differ per marketplace. If an invoice was already issued, a credit note is created automatically.`)
};

const de_faq_a_siparis_iptal = /** @type {(inputs: Faq_A_Siparis_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffne die Bestellung und klicke auf Stornieren. Die Stornoregeln unterscheiden sich je nach Plattform. Wurde bereits eine Rechnung ausgestellt, wird automatisch eine Gutschrift erstellt.`)
};

const ru_faq_a_siparis_iptal = /** @type {(inputs: Faq_A_Siparis_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте заказ и нажмите Отмена. Правила отмены отличаются в зависимости от площадки. Если счёт уже выставлен, автоматически создаётся кредит-нота.`)
};

/**
* | output |
* | --- |
* | "Open the order and click Cancel. Cancellation rules differ per marketplace. If an invoice was already issued, a credit note is created automatically." |
*
* @param {Faq_A_Siparis_IptalInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_siparis_iptal = /** @type {((inputs?: Faq_A_Siparis_IptalInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Siparis_IptalInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_siparis_iptal(inputs)
	if (locale === "de") return de_faq_a_siparis_iptal(inputs)
	if (locale === "ru") return ru_faq_a_siparis_iptal(inputs)
	return tr_faq_a_siparis_iptal(inputs)
});